module.exports = __webpack_public_path__ + "img/logo.b3be63a0.png";